import React, { useState } from 'react';
import { AddCircle } from '@mui/icons-material';
import { Button, Card, ListItemButton, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useFetch } from '../../../hooks/useFecth';
import ListPageLayout from '../../../components/ListPageLayout';
import DialogTeam from './components/DialogTeam';

export default function Team() {
    const { data, mutate, isFetching } = useFetch('teams');
    const [selected, setSelected] = useState();
    const rows = data ?? [];

    return (
        <>
            <ListPageLayout
                title="Cargos"
                subtitle="Cargos e permissões da equipe administrativa."
                counts={[{ label: 'cargos', value: rows.length, color: 'primary' }]}
                loading={isFetching && !data}
                showViewToggle={false}
                actions={
                    <Button size="small" variant="contained" startIcon={<AddCircle />} component={Link} to="#teams">
                        Adicionar cargo
                    </Button>
                }
                isEmpty={!isFetching && rows.length === 0}
            >
                <Stack spacing={1} p={2}>
                    {rows.map(item => (
                        <Card key={item.id} variant="outlined">
                            <ListItemButton
                                selected={selected?.id == item.id}
                                component={Link}
                                to={`#teams|${item.id}`}
                                onClick={() => setSelected(item)}
                                sx={{ py: 1.5 }}
                            >
                                <Typography fontWeight={600}>{item?.name}</Typography>
                            </ListItemButton>
                        </Card>
                    ))}
                </Stack>
            </ListPageLayout>
            <DialogTeam mutate={mutate} />
        </>
    );
}
